/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FAQsModuleDynamic } from '@coursera-web/cds-labs';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import useBrowseContentfulFaqs from 'bundles/browse-common/hooks/useBrowseContentfulFaqs';
import Markdown from 'bundles/cms/components/Markdown';
import useIsEqp from 'bundles/search-common/utils/useIsEqp';
import HelpCenterInfo from 'bundles/unified-common/components/HelpCenterInfo';
import Section from 'bundles/unified-description-page-common/components/shared/Section';

import _t from 'i18n!nls/browse-common';

const LoadableFAQsModule = createLoadableComponent(FAQsModuleDynamic);

const BrowseFAQsModuleRenderer = () => {
  const isEQPPage = useIsEqp();

  const { loading, error, pageContent } = useBrowseContentfulFaqs({
    isEntityPage: isEQPPage,
  });

  const { name } = pageContent || {};

  const getHeadline = () => {
    if (name) {
      return _t('Frequently asked questions about #{domainName} courses', {
        domainName: name,
      });
    } else {
      return _t('Frequently asked questions');
    }
  };

  if (error || (!loading && (!pageContent?.faqs || pageContent.faqs.length === 0))) {
    return null;
  }
  const markdownFaqs =
    !loading && pageContent?.faqs
      ? pageContent.faqs.map((faq) => {
          return {
            question: faq.question,
            plainTextAnswer: faq.answer,
            answer: <Markdown source={faq.answer} />,
          };
        })
      : [];

  return (
    <Section spacing={0} dataTestId="frequently-asked-questions">
      <LoadableFAQsModule
        headline={getHeadline()}
        headlineTypographyVariant="subtitleLarge"
        faqs={markdownFaqs}
        moreInfo={<HelpCenterInfo />}
      />
    </Section>
  );
};

export default BrowseFAQsModuleRenderer;
